const FilterBar = ({ searchTerm, setSearchTerm, selectedSources, setSelectedSources, /* startDate,
  setStartDate, endDate, setEndDate, */ onSearch, onClear, isVisible, setIsVisible
}) => {

  const handleCheckboxChange = (value) => {
    setSelectedSources((prev) =>
      prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value]
    );
  };

  return (
    <div className={`search-container ${isVisible ? 'visible' : 'hidden'}`}>
      {/* Close button at top edge */}
      <button
        className="close-filter-button"
        onClick={() => setIsVisible(false)}
        style={{ display: isVisible ? 'flex' : 'none' }}
        aria-label="Sulje suodatin"
        type="button"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
        </svg>
      </button>

      {/* Search field */}
        <input
          className='search-field'
          type='text'
          placeholder='Etsi...'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onSearch()}
        />

      {/* Sources checkboxes */}
      <div className='sources-container'>
        <label>
          <input
            type='checkbox'
            value='Vaarallisettuotteet.fi'
            checked={selectedSources.includes("Vaarallisettuotteet.fi")}
            onChange={() => handleCheckboxChange("Vaarallisettuotteet.fi")}
          />
          Tavarat
        </label>

        <label>
          <input
            type='checkbox'
            value='Ruokavirasto.fi'
            checked={selectedSources.includes("Ruokavirasto.fi")}
            onChange={() => handleCheckboxChange("Ruokavirasto.fi")}
          />
          Elintarvikkeet
        </label>
      </div>

      {/* Date pickers */}
      {/* <div className='date-filter-container'>
        <label>
          Alkaa
          <input
            type='date'
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          Päättyy
          <input
            type='date'
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div> */}

      {/* Buttons */}
      <div className='search-button-container'>
        <button onClick={onClear} className='clear-button'>
          Tyhjennä
        </button>
        <button onClick={onSearch} className='search-button'>
          Hae
        </button>
      </div>

    </div>
  );
};

export default FilterBar;